import { categories } from '@/mocks/categories';

export default function CategoriesSection() {
  return (
    <section id="categories" className="relative py-20 md:py-28 px-6 md:px-10 lg:px-16 bg-foreground-950">
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-primary-500/5 blur-3xl"></div>
        <div className="absolute -bottom-40 -left-40 w-[500px] h-[500px] rounded-full bg-accent-500/5 blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto flex flex-col items-center">
        {/* Section header */}
        <span className="text-xs font-semibold text-foreground-300 uppercase tracking-[0.2em] mb-4">Популярные категории</span>
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-background-50 text-center leading-tight mb-4">
          Найдите товары<br />в любой категории
        </h2>
        <p className="text-foreground-400 text-sm md:text-base max-w-xl text-center mb-12">
          Выберите категорию и перейдите к таблице с лучшими товарами из Китая
        </p>

        {/* Category cards grid with images */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4 w-full mb-12">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col bg-foreground-900/50 hover:bg-foreground-800/60 border border-foreground-800/30 hover:border-primary-500/40 rounded-xl overflow-hidden transition-all duration-300 cursor-pointer"
            >
              {/* Category image */}
              <div className="relative w-full aspect-square overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              {/* Category name */}
              <div className="px-3 py-3 flex items-center justify-center">
                <span className="text-xs md:text-sm font-medium text-foreground-200 group-hover:text-background-50 transition-colors text-center whitespace-nowrap">{cat.name}</span>
              </div>
            </a>
          ))}
        </div>

        {/* Bottom CTAs */}
        <div className="flex flex-col sm:flex-row gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 bg-background-50 text-foreground-900 rounded-full text-sm font-semibold hover:bg-background-100 transition-all text-center whitespace-nowrap cursor-pointer"
          >
            YOYBUY Sheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 border border-background-50/30 text-background-50 rounded-full text-sm font-semibold hover:bg-background-50/10 transition-all text-center whitespace-nowrap cursor-pointer"
          >
            Buy It Now
          </a>
        </div>
      </div>
    </section>
  );
}